import React, { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

const Pagina = ({ pdf, n, ancho, zoom }) => {
  const ref = useRef(null);
  useEffect(() => {
    let tarea; let vivo = true;
    pdf.getPage(n).then((p) => {
      if (!vivo || !ref.current) return;
      const base = p.getViewport({ scale: 1 });
      const escala = (ancho / base.width) * zoom;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const vp = p.getViewport({ scale: escala * dpr });
      const c = ref.current;
      c.width = vp.width; c.height = vp.height;
      c.style.width = `${vp.width / dpr}px`; c.style.height = `${vp.height / dpr}px`;
      tarea = p.render({ canvasContext: c.getContext("2d"), viewport: vp });
      tarea.promise.catch(() => {});
    });
    return () => { vivo = false; if (tarea) tarea.cancel(); };
  }, [pdf, n, ancho, zoom]);
  return <canvas ref={ref} data-page={n} data-testid={`visor-pdf-pagina-${n}`} className="bg-white shadow-md mx-auto block" />;
};

// Renderiza todas las páginas de un PDF dentro de la app (sin pestañas nuevas).
export const PdfPaginas = ({ blob, zoom, onPaginas, onPagina, onError, scrollRef }) => {
  const [pdf, setPdf] = useState(null);
  const ancho = Math.min(window.innerWidth - 24, 900);
  useEffect(() => {
    let vivo = true; let tarea;
    blob.arrayBuffer().then((buf) => {
      tarea = pdfjs.getDocument({ data: new Uint8Array(buf), isEvalSupported: false });
      return tarea.promise;
    }).then((d) => { if (vivo) { setPdf(d); onPaginas(d.numPages); } }).catch(() => vivo && onError());
    return () => { vivo = false; if (tarea) tarea.destroy(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blob]);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !pdf) return undefined;
    const fn = () => {
      const pags = [...el.querySelectorAll("canvas[data-page]")];
      const mitad = el.getBoundingClientRect().top + el.clientHeight / 2;
      const actual = pags.find((c) => c.getBoundingClientRect().bottom >= mitad);
      if (actual) onPagina(Number(actual.dataset.page));
    };
    el.addEventListener("scroll", fn, { passive: true });
    return () => el.removeEventListener("scroll", fn);
  }, [pdf, scrollRef, onPagina]);
  if (!pdf) return <p className="text-white/80 text-center py-10" data-testid="visor-cargando-pdf">Preparando el documento…</p>;
  return (
    <div className="space-y-3 py-3" style={{ width: zoom > 1 ? `${ancho * zoom}px` : "100%" }}>
      {Array.from({ length: pdf.numPages }, (_, i) => <Pagina key={i + 1} pdf={pdf} n={i + 1} ancho={ancho} zoom={zoom} />)}
    </div>
  );
};
